import { Injectable, Renderer2, RendererFactory2, inject } from '@angular/core';
import { UserDataService } from './core/user-data.service';

@Injectable({
  providedIn: 'root',
})
export class ColorSchemeService {
  private user = inject(UserDataService);

  private renderer: Renderer2;
  private colorScheme: string;
  private colorSchemePrefix = 'color-scheme-';

  constructor() {
    const rendererFactory = inject(RendererFactory2);

    // Create new renderer from renderFactory, to make it possible to use renderer2 in a service
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  _setColorScheme(scheme: string) {
    this.colorScheme = scheme;
    // Save prefers-color-scheme to localStorage
    localStorage.setItem('prefers-color', scheme);
  }

  _getColorScheme() {
    const migrationKey = 'dark-mode-migration-v2';
    const hasMigrated = localStorage.getItem(migrationKey);

    if (!hasMigrated) {
      // Force dark mode once for everyone
      this.user.setDarkMode(true);
      this._setColorScheme('dark');
      localStorage.setItem(migrationKey, 'true');
      return;
    }

    const localStorageColorScheme = localStorage.getItem('prefers-color');
    // Check if any prefers-color-scheme is stored in localStorage
    if (localStorageColorScheme) {
      // Save prefers-color-scheme from localStorage
      this.colorScheme = localStorageColorScheme;
      this.user.setDarkMode(localStorageColorScheme === 'dark' ? true : false);
    } else {
      this.user.setDarkMode(true);
      this._setColorScheme('dark');
    }
  }

  load() {
    this._getColorScheme();
    this.renderer.addClass(document.body, this.colorSchemePrefix + this.colorScheme);
    // if (!this.user.darkMode) this.renderer.addClass(.reversed-theme-palette, this.colorScheme + 'light')
  }

  update(scheme: string) {
    this._setColorScheme(scheme);
    // Remove the old color-scheme class
    this.renderer.removeClass(
      document.body,
      this.colorSchemePrefix + (this.colorScheme === 'dark' ? 'light' : 'dark')
    );
    // Add the new / current color-scheme class
    this.renderer.addClass(document.body, this.colorSchemePrefix + scheme);
  }

  currentActive() {
    return this.colorScheme;
  }
}
